import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
	children: ReactNode;
	resetKey?: string;
	fallback?: ReactNode;
}

interface State {
	hasError: boolean;
	error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error("ErrorBoundary caught:", error, errorInfo);
	}

	componentDidUpdate(prevProps: Props) {
		if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
			this.setState({ hasError: false, error: null });
		}
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) return this.props.fallback;

			return (
				<div style={{ padding: "2rem", textAlign: "center" }}>
					<h2>Algo salio mal</h2>
					<p style={{ color: "var(--text-muted)", marginTop: "0.5rem" }}>
						{this.state.error?.message || "Error inesperado"}
					</p>
					<button
						type="button"
						onClick={() => this.setState({ hasError: false, error: null })}
						style={{
							marginTop: "1rem",
							padding: "0.8rem 1.6rem",
							background: "var(--accent-color)",
							color: "white",
							border: "none",
							borderRadius: "var(--rounded-md)",
							cursor: "pointer",
						}}
					>
						Reintentar
					</button>
				</div>
			);
		}

		return this.props.children;
	}
}
